// import react from "react"
// import "../css/footer.css"

// function Footer(){
//     const arrow = "->"


//     const [isExtendedCol1 , setExtendedCol1] = react.useState(true)
//     const [isExtendedCol2 , setExtendedCol2] = react.useState(true)
//     const [isExtendedCol3 , setExtendedCol3] = react.useState(true)

//     function handleClick1(){
//         setExtendedCol1(prev=>!prev)
//     }
//     function handleClick2(){
//         setExtendedCol2(prev=>!prev)
//     }

//     function handleClick3(){
//          setExtendedCol3(prev=>!prev)
//     }




//     return(
//         <div className="Footer">
//                 <div className="max_width_footer">
//                     <div className="row row1">
//                         <div className="col1 col">
//                             <h4 onClick={handleClick1}>SHOP</h4>

//                             {isExtendedCol1 && 
//                             <span>
//                                 <a href="/ladies">Ladies</a>
//                                 <a href="/men">Men</a>
//                                 <a href="/baby">Baby</a>
//                                 <a href="/kids">Kids</a>
//                                 <a href="/home">H&M HOME</a>
//                                 <a href="/sport">Sport</a>
//                                 <a href="/magazine">Magazine</a>
//                             </span>}

//                         </div>
//                         <div className="col2 col">
//                             <h4  onClick={handleClick2}>CORPORATE INFO</h4>
//                             {   isExtendedCol2 &&                       
//                              <span>

//                                 <a href="ladies">Career at H&M</a>
//                                 <a href="https://hmgroup.com/about-us/">About H&M group</a>
//                                 <a href="bahttps://hmgroup.com/sustainability/by">Sustainability H&M Group</a>
//                                 <a href="https://about.hm.com/">Press</a>
//                                 <a href="https://hmgroup.com/investors/">Investor relations</a>
//                                 <a href="https://hmgroup.com/about-us/corporate-governance/">Corporate governance</a>

//                             </span>}

//                         </div>
//                         <div className="col3 col">
//                             <h4  onClick={handleClick3}>HELP</h4>
// { isExtendedCol3 &&                            <span>
//                             <a href="ladies">Customer Service</a>
//                                 <a href="men">My H&M</a>
//                                 <a href="findstore">Find a store</a>
//                                 <a href="kids">Legal & Privacy</a>
//                                 <a href="home">Contact</a>
//                                 <a href="sport">Report a scam</a>
//                                 <a href="magazine">Cookie Notice</a>                                
//                             </span>}
  
//                             {/* <a className="smol" href="magazine">Cookie Settings</a> */}
//                         </div>
//                         <div className="col4 col">
//                             <p>Sign up now and be the first to know about exclusive offers, latest fashion news & style tips!</p>
//                             <a href="https://www2.hm.com/en_in/customer-service/newsletter.html">Read more {arrow}</a>
//                         </div>
//                     </div>
//                     <div className="row row2">
//                         <span>
//                                 <i class="fa-brands fa-instagram"></i>
//                                 <i class="fa-brands fa-tiktok"></i>
//                                 <i class="fa-brands fa-youtube"></i>
//                                 <i class="fa-brands fa-pinterest"></i>
//                                 <i class="fa-brands fa-facebook"></i>
//                         </span>
//                         <p>
//                             The content of this site is copyright-protected and is the property of H & M Hennes & Mauritz AB.
//                         </p>
//                     </div>
//                     <div className="row row3">
//                         <img src="https://cdn.cookielaw.org/logos/6e0ffeab-df84-4fee-b293-9e6498bfa887/697b276d-c669-4d88-b115-dd9e6cae3fae/28a9d5ed-4776-4fe0-9e19-007e8ed817a9/709px-H&M-Logo.svg.png" alt="H&M"></img>
//                         <p>INDIA | Rs.</p>
//                     </div>

//                 </div>
//         </div>
//     )
// }

// export default Footer
import React, { useState } from "react";

function Footer() {
  const [email, setEmail] = useState("");
  const [expandedSection, setExpandedSection] = useState({
    products: true,
    account: true,
    help: true,
    contact: true
  });

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  const handleSubscribe = (e) => {
    e.preventDefault();
    // Add subscription logic here
    console.log("Subscribing with email:", email);
    setEmail("");
  };

  const toggleSection = (section) => {
    setExpandedSection(prev => ({
      ...prev,
      [section]: !prev[section]
    }));
  };

  return (
    <footer className="w-full bg-gray-50 py-8 px-4">
      <div className="max-w-6xl mx-auto">
        {/* Footer columns - Using flex for PC view instead of grid */}
        <div className="flex flex-col md:flex-row md:flex-wrap md:justify-between mb-8">
          {/* Products Column */}
          <div className="w-full md:w-1/4 mb-6 md:mb-0 pr-4">
            <h4 
              onClick={() => toggleSection("products")} 
              className="text-base font-semibold mb-4 flex justify-between items-center cursor-pointer md:cursor-default"
            >
              PRODUCTS
              <span className="block md:hidden">{expandedSection.products ? "-" : "+"}</span>
            </h4>
            <div className={`flex flex-col space-y-2 ${expandedSection.products ? "block" : "hidden md:block"}`}>
              <a href="/store/products" className="text-gray-600 hover:text-gray-900 transition-colors">Bowls</a>
              <a href="/store/products" className="text-gray-600 hover:text-gray-900 transition-colors">Baskets</a>
            </div>
          </div>
          
          {/* My Account Column */}
          <div className="w-full md:w-1/4 mb-6 md:mb-0 pr-4">
            <h4 
              onClick={() => toggleSection("account")} 
              className="text-base font-semibold mb-4 flex justify-between items-center cursor-pointer md:cursor-default"
            >
              MY ACCOUNT
              <span className="block md:hidden">{expandedSection.account ? "-" : "+"}</span>
            </h4>
            <div className={`flex flex-col space-y-2 ${expandedSection.account ? "block" : "hidden md:block"}`}>
              <a href="/profile" className="text-gray-600 hover:text-gray-900 transition-colors">Profile</a>
              <a href="/orders" className="text-gray-600 hover:text-gray-900 transition-colors">My Orders</a>
              <a href="/wishlist" className="text-gray-600 hover:text-gray-900 transition-colors">Wishlist</a>
            </div>
          </div>
          
          {/* Help Column */}
          <div className="w-full md:w-1/4 mb-6 md:mb-0 pr-4">
            <h4 
              onClick={() => toggleSection("help")} 
              className="text-base font-semibold mb-4 flex justify-between items-center cursor-pointer md:cursor-default"
            >
              HELP
              <span className="block md:hidden">{expandedSection.help ? "-" : "+"}</span>
            </h4>
            <div className={`flex flex-col space-y-2 ${expandedSection.help ? "block" : "hidden md:block"}`}>
            <a href="/faq" className="text-gray-600 hover:text-gray-900 transition-colors" title="Frequently Asked Questions">FAQs</a>
            <a href="https://merchant.razorpay.com/policy/QDNwFiwwCow1wQ/terms" target="_blank" rel="noopener noreferrer" className="text-gray-600 hover:text-gray-900 transition-colors" title="Terms and Conditions">Terms & Conditions</a>
            <a href="https://merchant.razorpay.com/policy/QDNwFiwwCow1wQ/privacy" target="_blank" rel="noopener noreferrer" className="text-gray-600 hover:text-gray-900 transition-colors" title="Privacy Policy">Privacy Policy</a>
            <a href="https://merchant.razorpay.com/policy/QDNwFiwwCow1wQ/refund" target="_blank" rel="noopener noreferrer" className="text-gray-600 hover:text-gray-900 transition-colors" title="Cancellation and Refund Policy">Cancellation & Refund Policy</a>
            <a href="https://merchant.razorpay.com/policy/QDNwFiwwCow1wQ/shipping" target="_blank" rel="noopener noreferrer" className="text-gray-600 hover:text-gray-900 transition-colors" title="Shipping and Delivery Policy">Shipping & Delivery Policy</a>

            </div>
          </div>
          
          {/* Contact Us Column */}
          <div className="w-full md:w-1/4 mb-6 md:mb-0">
            <h4 
              onClick={() => toggleSection("contact")} 
              className="text-base font-semibold mb-4 flex justify-between items-center cursor-pointer md:cursor-default"
            >
              CONTACT US
              <span className="block md:hidden">{expandedSection.contact ? "-" : "+"}</span>
            </h4>
            <div className={`space-y-4 ${expandedSection.contact ? "block" : "hidden md:block"}`}>
              <a 
                href="https://wa.me/+918398862901" 
                target="_blank" 
                rel="noreferrer" 
                className="flex items-center text-gray-600 hover:text-gray-900 transition-colors"
              >
                <i className="fa-brands fa-whatsapp mr-2"></i> On WhatsApp
              </a>
              <a 
                href="https://instagram.com/jute_cotton_basket01" 
                className="flex items-center text-gray-600 hover:text-gray-900 transition-colors"
              >
                <i className="fa-brands fa-instagram mr-2"></i> Follow on Instagram
              </a>         
             <a 
                href="https://merchant.razorpay.com/policy/QDNwFiwwCow1wQ/contact_us" 
                className="flex items-center text-gray-600 hover:text-gray-900 transition-colors"
              >
                <i className="fa-light fa-phone-office mr-2"></i> Contact Us
              </a>

              
              {/* Newsletter */}
              {/* <div className="mt-4">
                <p className="text-sm text-gray-600 mb-2">Sign up for our newsletter to receive updates and exclusive offers</p>
                <form onSubmit={handleSubscribe} className="mt-2">
                  <div className="flex flex-col sm:flex-row gap-2">
                    <input 
                      type="email" 
                      placeholder="Your email" 
                      value={email}
                      onChange={handleEmailChange}
                      required
                      className="flex-grow px-3 py-2 border border-gray-300 text-sm focus:outline-none focus:ring-1 focus:ring-gray-500"
                    />
                    <button 
                      type="submit" 
                      className="px-4 py-2 bg-gray-800 text-white text-sm hover:bg-gray-700 transition-colors"
                    >
                      Subscribe
                    </button>
                  </div>
                </form>
              </div> */}
            </div>
          </div>
        </div>

        {/* Social Links */}
        <div className="flex justify-center space-x-6 my-6">
          <a 
            href="https://wa.me/+918398862901" 
            className="text-gray-600 hover:text-gray-900 text-xl transition-colors"
          >
            <i className="fa-brands fa-whatsapp"></i>
          </a>
          <a 
            href="https://instagram.com/jute_cotton_basket01" 
            className="text-gray-600 hover:text-gray-900 text-xl transition-colors"
          >
            <i className="fa-brands fa-instagram"></i>
          </a>
        </div>

        {/* Footer Bottom */}
        <div className="pt-4 border-t border-gray-200 flex flex-col md:flex-row justify-between items-center text-sm text-gray-500">
          <p>Jutexx. All rights reserved.</p>
          <div className="mt-2 md:mt-0">
          <a href="https://stats.uptimerobot.com/cRVMVykwGa" target="_blank" rel="noreferrer">Check Uptime</a>
            {/* <a href="/privacy-policy" className="hover:text-gray-700 mr-4">Privacy Policy</a> */}
            {/* <a href="/terms-of-service" className="hover:text-gray-700">Terms of Service</a> */}
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;